import React, { useState } from "react";
import Select from "react-select";

export default function Filter(props) {
  const [selectedOptions, setSelectedOptions] = useState([]);

  let amenitiesData = props?.rooms?.map((item) => item?.amenities || []);

  const uniqueAmenities = Array.from(
    new Map(
      amenitiesData.map((item) => [
        item.name + "|" + item.code + "|" + item.category,
        item,
      ])
    ).values()
  );

  const roomFilterData = props?.rooms?.map((item) => {
    return {
      value: item.serviceId,
      label: item.name,
    };
  });

  const handleCheckboxChange = (event) => {
    const { value, checked } = event.target;

    let updatedSelected;
    if (checked) {
      updatedSelected = [...selectedOptions, value];
    } else {
      updatedSelected = selectedOptions.filter((item) => item !== value);
    }
    setSelectedOptions(updatedSelected);
      props.handlePassMultiCheckBox(updatedSelected);

  };

  return (
    <div style={{ minHeight: "50vh" }}>
      <h6>Rooms</h6>
      <Select
        // defaultValue={[colourOptions[2], colourOptions[3]]}
        // isMultiss
        name="rooms"
        options={roomFilterData}
        className="basic-multi-select"
        classNamePrefix="select"
        onChange={(e) => props.handleSelectDrop(e)}
      />
      <br />
      <h6>Rooms Preferences</h6>
      <div className="">
        {uniqueAmenities?.[0]?.map((option) => {
          return (
            <div className="d-flex align-items-start" key={option?.code}>
              <input
                type="checkbox"
                id={option?.code}
                value={option?.code}
                // checked={selectedOptions.includes(option?.value)}
                onChange={handleCheckboxChange}
              />
              <label className="font-14" htmlFor={option?.code}>
                &nbsp;&nbsp;{option?.code}
              </label>
            </div>
          );
        })}
      </div>

      {/* <button onClick={props.handleApply}>Apply</button> */}
    </div>
  );
}
